import 'rev-shared/bootstrap/SharedImports';

import { bootstrapAngularApp } from 'rev-shared/bootstrap/AngularAppBootstrapUtils';
import { PortalAngularModule } from './PortalAngular.Module';

bootstrapAngularApp(PortalAngularModule);
